<template>
  <modal v-bind="$attrs" v-on="$listeners" :center="true">
    <template v-slot:body>
      <div>
        <h4 id="success-modal-message">{{ page==0 ? $t('study_sets.modals.createAssignmentSuccess.new_assignments_status'):(page==1 ? $t('homework.modals.create_success'):$t('homework.modals.assign_to_class.assign_success')) }}</h4>
        <el-row type="flex" style="width: 100%">
          <el-col id="creativity" :span="8">
            <img v-if="page==0" :src="getIconUrl" />
            <img v-else-if="page==2" :src="getIconUrl3" class="img-2"/>
            <img v-else :src="getIconUrl2" class="img-2"/>
          </el-col>
          <el-col :span="16">
            <ul class="list-none assignments">
              <li v-for="assignment in createdAssignments" :key="assignment.id" class="assignment">
                <div v-if="assignment.study_set_used">
                    <p class="info-row">
                  {{ $t('study_sets.modals.createAssignmentSuccess.assignment_name') }}: <span>{{ assignment.assignment_name[0] }}</span><i v-bind:class="page==0 ?'elsa-icon-exclamation-circle align-icon':'align-icon'" />
                </p>
                  <p class="error-row">{{ assignment.study_set_used[0] }}</p>
                </div>
                <div v-else>
                  <p class="info-row">
                    {{ $t('study_sets.modals.createAssignmentSuccess.assignment_name') }}: <span>{{ assignment.name }}</span><i v-bind:class="page==0 ?'elsa-icon-check-circle align-icon':'align-icon'" />
                  </p>
                  <p class="info-row">
                    {{ $t('study_sets.modals.createAssignmentSuccess.assigned_to') }}: <span>{{ assignment.group_name }}</span>
                  </p>
                  <p class="info-row">
                    {{ $t('study_sets.modals.createAssignmentSuccess.due_date') }}: <span>{{ formatDate(assignment.due_date) }}</span>
                  </p>
                </div>
              </li>
            </ul>
          </el-col>
        </el-row>
        <el-row class="flex" justify="center">
          <primary-button class="assign-class" ref="" @click.native="$emit('closed')">
            {{ page==0 ? $t('common.finish'):$t('common.ok') }}
          </primary-button>
        </el-row>
      </div>
    </template>
  </modal>
</template>

<script>
import Modal from '@/components/common/Modal'
import PrimaryButton from '@/components/common/buttons/PrimaryButton'
import { mapActions, mapGetters } from 'vuex'
import { format } from 'date-fns'
import { DATE_FORMAT } from "@/constants/generic"

export default {
  props: {
    dateFormat: {
      type: String,
      default: DATE_FORMAT
    },
    page: {
      type: Number,
      default: 0
    },
    createdAssignments: {
    }
  },
  components: {
    Modal,
    PrimaryButton
  },
  computed: {
    ...mapGetters({
      currentOrganizationType: 'organization/currentOrganizationType',
    }),
    getIconUrl() {
      return require(`@/assets/images/notebook.svg`)
    },
    getIconUrl2() {
      return require(`@/assets/images/assignment-success.png`)
    },
    getIconUrl3() {
      return require(`@/assets/images/books.png`)
    },
    getTitle() {
      return this.$t(this.$i18nLabelsHelper(this.currentOrganizationType, 'modals.delete.title'), {
        numberOfClasses: this.numberOfSelectedClasses
      })
    }
  },
  methods: {
    formatDate(date) {
      return date ? format(new Date(date), this.dateFormat) : '--'
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../scss/_colors.scss';

.new-study-set {
  color: $hyperlink;
  padding-left: 0px !important;
  padding-bottom: 0px !important;
  margin-top: auto;
}

.new-study-set {
  &::v-deep span {
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      height: 12px;
      width: 12px;
      fill: $hyperlink;
      padding-left: 0px;
    }
  }
}

.new-study-set:hover {
  color: $hyperlink;

  &::v-deep span {
    img {
      fill: $hyperlink-hover;
    }
  }
}

.assignment {
  background: #e7e7e7;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 16px;
}

.assignments {
  > :last-child {
    margin-bottom: 0px;
    box-shadow: none;
  }
}
.detail {
  margin-top: 24px;
}
.info-row {
  margin: 0px 0px 8px 0px;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: $black;
  span {
    font-size: 18px;
    font-weight: 600;
  }
}

.error-row {
  margin: 0px 0px 8px 0px;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #E00700;
}

#success-modal-message {
  font-weight: 700;
  font-size: 24px;
  line-height: 32px;

  color: $black;
  margin: 0 auto;
  white-space: pre-wrap;
}

.elsa-button.assign-class,
.elsa-button.assign-class:hover {
  border-radius: 8px;
  padding-left: 32px;
  padding-right: 32px;
  margin-left: 4px;
}

::v-deep {
  .el-dialog.elsa-modal {
    width: 720px;
    .el-dialog__header,
    .el-dialog__body {
      // display: flex;
      background-color: white;
    }

    &.signup .el-dialog__body {
      padding: 0;
    }

    .el-dialog__header {
      border-top-left-radius: 16px;
      border-top-right-radius: 16px;
      min-height: 27.5px;
    }

    .el-dialog__body {
      padding: 0px 32px 32px 32px;
      border-top: none;
      & > *:not(p):not(.info) {
        padding-bottom: 6px;
        display: flex;
        flex-direction: column;
      }
    }

    .el-dialog__footer {
      padding: 0 20px 48px 20px;
      justify-content: center;
    }
  }
}

.align-icon {
  display: inline-block !important;
  float: right !important;
}

#creativity {
  display: flex;
  justify-content: center;
  .img-2 {
    width:142px;
    margin-top: 16px;
  }
}
</style>
